<script setup>
import {Modal} from 'ant-design-vue';
import {defineProps, defineEmits, watch, ref} from 'vue';
import {shortenEmail, shortenPhone} from "@/utils/validate";

// Nhận props
const props = defineProps({
  visible: Boolean,
  initialData: {
    type: Object,
    default: null
  }
});

const players = ref([]);
const team = ref(props.initialData);

// Emit sự kiện
const emit = defineEmits(['update:visible', 'success', 'cancel']);

const handleCancel = () => {
  emit('update:visible', false);
  emit('cancel');
};

watch(
    () => props.initialData,
    (initData) => {
      if (initData) {
        team.value = initData;
        players.value = initData.players;
      } else {
        console.log("no field")
      }
    },
);
</script>

<template>
  <Modal
      :open="props.visible"
      title="Xem thông tin chi đội"
      width="600px"
      okText="Đóng"
      cancelText="Hủy bỏ"
      @cancel="handleCancel"
      @ok="handleCancel"
  >
    <div class="row">
      <div class="col-lg-12">
        <div class="master-academy dull-whitesmoke-bg card master-academyview">
          <div class="row d-flex align-items-center justify-content-start">
            <div class="col-12">
              <div class="d-sm-flex justify-content-start align-items-center">
                <div class="info">
                  <div>Tên đội: <h4 class="mb-2 d-flex gap-2">{{ team?.name }}</h4>
                  </div>

                  <div class="d-flex gap-2">
                    <span>Tổng số vận động viên: </span>
                    <h6>{{ players.length }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="profile-tab">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button id="team_detail" aria-selected="true" class="nav-link active"
                      data-bs-target="#team_detail_info"
                      data-bs-toggle="tab" role="tab" type="button">
                Danh sách vận động viên
              </button>
            </li>
          </ul>
          <div class="tab-content">
            <div id="team_detail_info" class="tab-pane fade show active" role="tabpanel">
              <div v-for="(item, index) in players" :key="item?.documentId ?? index"
                   class="">
                  <div class="d-flex gap-2 align-items-end">{{ index + 1 }}. <h4 class="p-0 m-0">{{ item?.first_name ?? '---' }} {{ item?.middle_name ?? '' }} {{ item?.last_name ?? '---' }}</h4></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<style scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
